import axios from 'axios';
import { USERMASTERAPIHOME, configFileURL } from './config';

const header = { 'content-type': 'application/json' };

class UserMasterService {

    constructor() {

        this.CallUserProfileAPI = (userId) => (axios.post(`${USERMASTERAPIHOME}userprofileapi`, { userId }));

        this.CallLoginAPI = (payload) => (axios.post(`${USERMASTERAPIHOME}callloginapi`, payload));

        this.CallForgetPasswordAPI = (userId) => (axios.post(`${USERMASTERAPIHOME}forgetpasswordapi`, { userId }));

        this.CallResetPasswordAPI = (payload) => (axios.post(`${USERMASTERAPIHOME}resetpasswordapi`, payload));

        this.CallRegistrationAPI = (payload) => (axios.post(`${USERMASTERAPIHOME}registrationapi`, payload));

        this.InsertIntoUserMaster = (payload) => (axios.post(`${USERMASTERAPIHOME}insertintousermaster`, payload))

        this.updateonusermaster = (payload) => (axios.post(`${USERMASTERAPIHOME}updateonusermaster`, payload))

        this.CallInsertAPI = (payload) => (axios.post(`${USERMASTERAPIHOME}insertintousermaster`, payload))

        this.getUserMasterListData = () => (axios.post(`${USERMASTERAPIHOME}getusermasterlistdata`))

        this.setuserstatus = (payload) => (axios.post(`${USERMASTERAPIHOME}setuserstatus`, payload))

        this.getroledata = () => (axios.post(`${USERMASTERAPIHOME}getroledata`))

        this.validateJJEmployee = (payload) => (axios.post(`${USERMASTERAPIHOME}validatejjemployee`, payload))

        this.getsettings = () => (axios.post(`${USERMASTERAPIHOME}getsettings`, null))

        this.LogOut = () => (axios.post(`${USERMASTERAPIHOME}logout`))

        this.GetBSFranchise = (payload) => (axios.post(`${USERMASTERAPIHOME}getbsfranchise`, payload))

        this.configFileURL = () => (axios.get(configFileURL, "", header));

        this.validateapplicationtoken = (payload) => (axios.post(`${USERMASTERAPIHOME}validateapplicationtoken`, payload, header));

        this.ValidateEntGateLoginApplicationToken = (payload) => (axios.post(`${USERMASTERAPIHOME}ValidateEntGateLoginApplicationToken`, payload, header));

        this.GetEnableLoginRedirect = () => (axios.post(`${USERMASTERAPIHOME}getenableloginredirect`));

        this.getactiveapplications = (payload) => (axios.post(`${USERMASTERAPIHOME}getactiveapplications`, payload, header));

        this.getProjectUrl = () => (axios.get(`${USERMASTERAPIHOME}getProjectUrl`));

        this.GetDataUserAccessList = () => (axios.post(`${USERMASTERAPIHOME}getDatauseraccesslist`));

        this.SwitchToUser = (payload) => (axios.post(`${USERMASTERAPIHOME}SwitchToUser`, payload));

        this.SwitchBackToOriginalUser = (payload) => (axios.post(`${USERMASTERAPIHOME}SwitchBackToOriginalUser`, payload));
    }
}
export default new UserMasterService();